<template>
  <div class="form-error">
    <p class="form-memo" v-for="err in errors" :key="err">
      <i class="fas fa-exclamation-circle"></i>
      <span>{{ err }}</span>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      required: true
    }
  }
}
</script>
